import { type Component } from "solid-js";
import Header from "./header";
import usePermissions from "src/lib/usePermissions";
import { Navigate } from "@solidjs/router";

// Layout tanpa <Outlet />
const Layout: Component<{ page: Component; permission?: string }> = (props) => {
  const permissions = usePermissions();
  if (props.permission && !permissions().has(props.permission)) {
    return <Navigate href="/401" />;
  }
  return (
    <>
      <Header />
      <main
        class="w-full h-full p-8 pt-8 md:pb-12 md:px-12 lg:pb-16 lg:px-16 xl:pb-24 xl:px-24 2xl:pb-32 2xl:px-32"
        style={{ "min-height": "calc(100vh - 107px)" }}
      >
        <props.page />
      </main>
    </>
  );
};

export default Layout;
